export const devURL = "https://danahzohar.com/api";
export const wpURL = "https://danahzohar.com/__wp";


// export const devURL = "http://localhost:8080";
// export const wpURL = "http://localhost:9090";